import { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import PlatformDialog from '../../molecules/PlatformDialog/PlatformDialog';
import PlatformDialogTitle from '../../molecules/PlatformDialog/PlatformDialogTitle';
import { Label as LabelIcon, Add as AddIcon } from '@mui/icons-material';

const CreateTagDialog = ({ open, onClose, onSave }) => {
  const [tagName, setTagName] = useState('');
  const [error, setError] = useState('');
  const [classificationType, setClassificationType] = useState('neutral');
  const [competitorName, setCompetitorName] = useState('');

  const handleClose = () => {
    setTagName('');
    setError('');
    setClassificationType('neutral');
    setCompetitorName('');
    onClose();
  };

  const handleSave = () => {
    const name = tagName.trim();
    if (!name) {
      setError('O nome da tag é obrigatório');
      return;
    }
    if (classificationType === 'competitor' && !competitorName.trim()) {
      setError('Informe o nome do concorrente');
      return;
    }
    onSave({
      name,
      classificationType,
      competitorName: classificationType === 'competitor' ? competitorName.trim() : null
    });
    setTagName('');
    setError('');
    setClassificationType('neutral');
    setCompetitorName('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && tagName.trim()) {
      handleSave();
    }
  };

  return (
    <PlatformDialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      <PlatformDialogTitle
        title="Criar Nova Tag"
        subtitle="Digite o nome da nova tag"
        icon={<LabelIcon />}
        onClose={handleClose}
      />
      
      <Box sx={{ px: 3, pb: 3 }}>
        <TextField
          autoFocus
          fullWidth
          label="Nome da Tag"
          placeholder="Ex: Marketing Digital"
          value={tagName}
          onChange={(e) => {
            setTagName(e.target.value);
            setError('');
          }}
          onKeyDown={handleKeyDown}
          error={!!error}
          helperText={error}
          sx={{ mb: 2 }}
        />

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Classificação</InputLabel>
          <Select value={classificationType} label="Classificação" onChange={(e) => setClassificationType(e.target.value)}>
            <MenuItem value="brand">Marca</MenuItem>
            <MenuItem value="competitor">Concorrente</MenuItem>
            <MenuItem value="neutral">Neutra (editorial/organizacional)</MenuItem>
          </Select>
        </FormControl>

        {classificationType === 'competitor' && (
          <TextField
            fullWidth
            label="Nome do concorrente"
            value={competitorName}
            onChange={(e) => { setCompetitorName(e.target.value); setError(''); }}
            sx={{ mb: 2 }}
          />
        )}
        
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button onClick={handleClose} sx={{ fontWeight: 600 }}>
            Cancelar
          </Button>
          <Button 
            variant="contained" 
            onClick={handleSave}
            disabled={!tagName.trim()}
            startIcon={<AddIcon />}
            sx={{ fontWeight: 700 }}
          >
            Criar Tag
          </Button>
        </Box>
      </Box>
    </PlatformDialog>
  );
};

CreateTagDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default CreateTagDialog;
